import { useEffect, useState } from "react";

// Mobile view: the main menu is the bar at the bottom of the screen (same width
// as in styles/components/single_column.scss, $no-gap-breakpoint - 285px - 1px).
// There, these entries move from the bar into the menu behind the avatar.
export const MOBILE_NAV_QUERY = "(max-width: 889px)";
export const AVATAR_MENU_ITEMS = ["drafts", "scheduled_statuses", "account_settings", "app_settings"];

const query = () => (typeof window !== "undefined" && window.matchMedia ? window.matchMedia(MOBILE_NAV_QUERY) : null);

export const isMobileNav = () => !!query()?.matches;

// True while the window is narrow enough for the mobile view, updates on resize.
export const useMobileNav = () => {
  const [mobile, setMobile] = useState(isMobileNav);

  useEffect(() => {
    const mq = query();
    if (!mq) {
      return undefined;
    }
    const update = () => setMobile(mq.matches);
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);

  return mobile;
};
